import PropTypes from 'prop-types'

import { useUserData } from '@hooks/use_user_data'

import { getIcon } from './helpers'
import ProfileImagePlaceholder from './placeholder'
import * as styles from './styles'

const ProfileImage = ({ size }) => {
  const { data, loading } = useUserData()

  if (loading) {
    return (
      <ProfileImagePlaceholder
        width={size}
        height={size}
      />
    )
  }

  const renderIcon = () => {
    const Icon = getIcon(data)

    return (
      <Icon
        size={size}
        color='white-300'
      />
    )
  }

  return (
    <div
      css={styles.container(size)}
      data-testid='profile-img'
    >
      {renderIcon()}
    </div>
  )
}

ProfileImage.propTypes = {
  size: PropTypes.string.isRequired
}

export default ProfileImage
